import { render, staticRenderFns } from "./handler.vue?vue&type=template&id=3e248249"
import script from "./handler.vue?vue&type=script&lang=js"
export * from "./handler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports